import Color from "./captionsettings/Color"

export default class CaptionData {

  constructor() {
    return {
      fontFamily: [
        {label: "Monospaced Serif", value: "'Courier New', Courier, 'Nimbus Mono L', 'Cutive Mono', monospace"},
        {label: "Proportional Serif", value: "'Times New Roman', Times, Georgia, Cambria, 'PT Serif Caption', serif"},
        {label: "Monospaced Sans-Serif", value: "'Deja Vu Sans Mono', 'Lucida Console', Monaco, Consolas, 'PT Mono', monospace"},
        {label: "Proportional Sans-Serif", value: "Roboto, 'Arial Unicode Ms', Arial, Helvetica, Verdana, 'PT Sans Caption', sans-serif"},
        {label: "Casual", value: "'Comic Sans MS', Impact, Handlee, fantasy"},
        {label: "Cursive", value: "'Monotype Corsiva', 'URW Chancery L', 'Apple Chancery', 'Dancing Script', cursive"},
        {label: "Small Capitals", value: "'Arial Unicode Ms', Arial, Helvetica, Verdana, 'Marcellus SC', sans-serif; font-variant: small-caps"}
      ],
      fontColor: [
        {label: "White", value: new Color(255, 255, 255)},
        {label: "Yellow", value: new Color(255, 255, 0)},
        {label: "Green", value: new Color(0, 128, 0)},
        {label: "Cyan", value: new Color(0, 255, 255)},
        {label: "Blue", value: new Color(0, 0, 255)},
        {label: "Magenta", value: new Color(255, 0, 255)},
        {label: "Red", value: new Color(255, 0, 0)},
        {label: "Black", value: new Color(0, 0, 0)}
      ],
      size: [
        {label: "70%", value: "x-small"},
        {label: "100%", value: "small"},
        {label: "150%", value: "medium"},
        {label: "200%", value: "large"},
        {label: "300%", value: "x-large"}
      ],
      fontOpacity: [
        {label: "25%", value: 0.25},
        {label: "50%", value: 0.5},
        {label: "75%", value: 0.75},
        {label: "100%", value: 1}
      ],
      backgroundColor: [
        {label: "White", value: new Color(255,255,255)},
        {label: "Yellow", value: new Color(255,255,0)},
        {label: "Green", value: new Color(0,128,0)},
        {label: "Cyan", value: new Color(0,255,255)},
        {label: "Blue", value: new Color(0,0,255)},
        {label: "Magenta", value: new Color(255,0,255)},
        {label: "Red", value: new Color(255,0,0)},
        {label: "Black", value: new Color(0,0,0)}
      ],
      backgroundOpacity: [
        {label: "0%", value: 0},
        {label: "25%", value: 0.25},
        {label: "50%", value: 0.5},
        {label: "75%", value: 0.75},
        {label: "100%", value: 1}
      ],
      edgeType: [
        {label: "None", value: "text-shadow: 0px 0px 0px"},
        {label: "Depressed", value: "text-shadow: 0px 1px 0px"},
        {label: "Left Drop Shadow", value: "text-shadow: -3px 3px 2px"},
        {label: "Raised", value: "text-shadow: 0px 1px 1px"},
        {label: "Right Drop Shadow", value: "text-shadow: 3px 3px 2px"},
        {label: "Uniform", value: "text-shadow: 0px 0px 4px"}
      ],
      edgeColor: [
        {label: "White", value: new Color(255, 255, 255)},
        {label: "Yellow", value: new Color(255, 255, 0)},
        {label: "Green", value: new Color(0, 128, 0)},
        {label: "Cyan", value: new Color(0, 255, 255)},
        {label: "Blue", value: new Color(0, 0, 255)},
        {label: "Magenta", value: new Color(255, 0, 255)},
        {label: "Red", value: new Color(255, 0, 0)},
        {label: "Black", value: new Color(0, 0, 0)}
      ],
      edgeOpacity: [
        {label: "0%", value: 0},
        {label: "25%", value: 0.25},
        {label: "50%", value: 0.5},
        {label: "75%", value: 0.75},
        {label: "100%", value: 1}
      ],
      fontOpacity: [
        {label: "25%", value: 0.25},
        {label: "50%", value: 0.5},
        {label: "75%", value: 0.75},
        {label: "100%", value: 1}
      ],
      scroll: [
        {label: "Pop-out", value: "popout"},
        {label: "Roll-on", value: "rollon"},
        {label: "Paint-on", value: "painton"}
      ],
      windowColor: [
        {label: "White", value: new Color(255, 255, 255)},
        {label: "Yellow", value: new Color(255, 255, 0)},
        {label: "Green", value: new Color(0, 128, 0)},
        {label: "Cyan", value: new Color(0, 255, 255)},
        {label: "Blue", value: new Color(0, 0, 255)},
        {label: "Magenta", value: new Color(255, 0, 255)},
        {label: "Red", value: new Color(255, 0, 0)},
        {label: "Black", value: new Color(0, 0, 0)}
      ],
      windowOpacity: [
        {label: "0%", value: 0},
        {label: "25%", value: 0.25},
        {label: "50%", value: 0.5},
        {label: "75%", value: 0.75},
        {label: "100%", value: 1}
      ]
    }
  }
}
